import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SearchModeEnum } from '~/attendee/components/pages/home/filters/enum/search-mode.enum';
import { DateRangeInterface } from '~/attendee/components/shared/date-range-input/date-range-input.component';
import { getFormatedSearchParams } from '~/attendee/helpers/result-page/search-helper';
import { UpdateFilterPayloadInterface } from '~/attendee/interfaces/update-filter-payload.interface';
import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { InputStyleEnum } from '~/component/form/input/enums/style.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  template: '',
})
export class AttendeeHomeFiltersComponent {
  @Input() public city?: string;
  @Input() public dateRange?: DateRangeInterface;
  @Input() public placeId?: string;
  @Input() public radius?: number;
  @Input() public searchMode?: SearchModeEnum;
  @Input() public sportsGroup?: number;
  @Output() public searched = new EventEmitter<
    UpdateFilterPayloadInterface[]
  >();
  public readonly iconType = VtmnPlayIconTypeEnum;
  public readonly inputStyle = InputStyleEnum;
  public readonly searchModeEnum = SearchModeEnum;
  public readonly vtmnPlayButtonSize = VtmnPlayButtonSizeEnum;

  public get isSearchAuto(): boolean {
    return this.searchMode === this.searchModeEnum.AUTO;
  }

  public handleAutocompleteClear(): void {
    this.placeId = null;
    this.radius = null;

    this.handleAutoSearch();
  }

  public handleAutoSearch(): void {
    if (this.isSearchAuto) {
      this.search();
    }
  }

  public search(): void {
    this.searched.emit(
      getFormatedSearchParams({
        city: this.city,
        radius: this.radius,
        dateRange: this.dateRange,
        sportsGroup: this.sportsGroup,
        placeId: this.placeId,
      })
    );
  }

  public selectDateRange(dateRange: DateRangeInterface): void {
    if (this.dateRange === dateRange) {
      return;
    }

    this.dateRange = dateRange;
    this.handleAutoSearch();
  }

  public selectPlace({
    city,
    placeId,
  }: {
    city: string;
    placeId: string;
  }): void {
    this.city = city;
    this.placeId = placeId;
  }

  public selectRadius(radius: number): void {
    this.radius = radius;
    this.handleAutoSearch();
  }

  public selectSportsGroup({ sportsGroupId }: { sportsGroupId: number }): void {
    if (this.sportsGroup === sportsGroupId) {
      return;
    }

    this.sportsGroup = sportsGroupId;
    this.handleAutoSearch();
  }

  public updateFilter(payloads: UpdateFilterPayloadInterface[]): void {
    this.searched.emit(payloads);
  }
}
